/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Removing internal links (SEO directive)
navLinkFn = function(e) {
  e.preventDefault();
  window.location.href = $(this).attr('data-url');
  console.log($(this).attr('data-url'));
}

var navLinks = document.getElementsByClassName('link-nav');
for (var i=0; i < navLinks.length; i++) {
    navLinks.item(i).onclick = navLinkFn;
}

function popupUpgrades(u) {
  window[`close-upgrades-popup`] = document.getElementById("close-upgrades-popup-" + $(u).data('id'));  
  window[`overlay-upgrades-popup`] = document.getElementById("overlay-upgrades-popup-" + $(u).data('id'));                                                         
  window[`upgrades-popup`] = document.getElementById("upgrades-popup-" + $(u).data('id'));                                                                                                               

  window[`overlay-upgrades-popup`].onclick = function() {
    window[`overlay-upgrades-popup`].classList.remove("show");
    window[`upgrades-popup`].classList.remove("show");
  };

  window[`close-upgrades-popup`].onclick = function() {
    window[`overlay-upgrades-popup`].classList.remove("show");
    window[`upgrades-popup`].classList.remove("show");
  };

  window[`overlay-upgrades-popup`].classList.add("show");
  window[`upgrades-popup`].classList.add("show");
};

$(document).ready(function(){
    
  addToCart();
  CollectionAddToCart();
  upgradeAddToCart();
  
  function addToCart(){

    $('#hijacked').on('click', function(){
      var vid = $(this).attr('data-vid');
      var flitecell = 'Sport';
      var upgrade = $("#flitecell-upgrade").prop('checked');    
      if(upgrade == true){
      	vid = $(this).attr('data-altvid');
        flitecell = 'Explore';
      }
      
      let formData = {
        'items': [{
          'id': vid,
          'quantity': 1,
          'properties': {
            "Flitecell": flitecell
          }
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally((response) => {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1
          }
        }))
      })
    });
  };
  
  function CollectionAddToCart() {
    
    $('.CollectionAddToCart').on('click', function(e) {
      e.preventDefault();
      var this_form = $(this).parents('form:first');
      var this_variant = this_form.data('variant-id');
      var jqxhr = $.post('/cart/add.js', $(this_form).serialize());

      jqxhr.always(function() {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: this_variant,
            quantity: 1
          }
        }))
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      })
    });
  };
  
  function upgradeAddToCart(){
    
    $('body').on('click', '.upgradeAddToCart', function (){
      var vid = $(this).attr('data-vid');

      let formData = {
        'items': [{
          'id': vid,
          'quantity': 1
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally((response) => {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: vid,
            quantity: 1
          }
        }))
      })
    });
  };
});

  $(".slidedown-trigger").click(function(){
    let id = this.dataset.id
    
    $(`#slidedown-${id}`).toggleClass("slidedown-hidden");
    $(`#blur-${id}`).toggleClass("d-none");
    $(`#blur-${id}`).toggleClass("backdrop-blur");
  })
  
  $(".slideout-trigger").click(function(){
    let id = this.dataset.id
    $(`#overlay-${id}`).toggleClass("slideout-overlay-open");
    
    if ( $(`#information-${id}`).hasClass('transparent') ){
      setTimeout(function(){
        $(`#information-${id}`).toggleClass("transparent", 400);
        $(`#blur-${id}`).toggleClass("d-none");
        $(`#blur-${id}`).toggleClass("backdrop-blur");
        $(`.video-${id}`).toggleClass("blur");
        $(`#bg-image-${id}`).toggleClass("blur");
      }, 200);
    } else {
      $(`#information-${id}`).toggleClass("transparent", 400);
      $(`#blur-${id}`).toggleClass("d-none");
      $(`#blur-${id}`).toggleClass("backdrop-blur");
      $(`.video-${id}`).toggleClass("blur");
      $(`#bg-image-${id}`).toggleClass("blur");
    }
  })












function startCountdown() {
    const countdownElements = document.querySelectorAll(".lab-countdown");
    if (countdownElements.length === 0) return;
    
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 5);
    targetDate.setHours(0, 0, 0, 0);
    
    function updateCountdown() {
        const now = new Date();
        const diff = targetDate - now;
        
        if (diff <= 0) {
            countdownElements.forEach(el => el.textContent = "00d 00h 00m 00s");
            clearInterval(interval);
            return;
        }
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        
        countdownElements.forEach(el => {
            el.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        });
    }
    
    setTimeout(() => {
        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
    }, 5000);
}

document.addEventListener("DOMContentLoaded", () => {
    setTimeout(startCountdown, 1000);
});